const CalendarColorSchemes = [
  {
    name: "activities",
    label: "Por tipo da atividade",
    mapping: new Map([
      ["email", { color: "#2e96d7", label: "E-mail" }],
      ["ligacao", { color: "#3126E6", label: "Ligação" }],
      ["whatsapp", { color: "#1cc559", label: "WhatsApp" }],
      ["proposta", { color: "#dba217", label: "Proposta" }],
      ["reuniao", { color: "#dc9d74", label: "Reunião" }],
      ["visita", { color: "#b63333", label: "Visita" }],
      ["semTipo", { color: "#9393c2", label: "Sem Tipo" }]
    ]),
    defaultColor: "#9393c2",
    colorFor: function(activity) {
      const key = activity.metric ? activity.metric.toLowerCase() : null;

      return this.mapping.has(key)
        ? this.mapping.get(key).color
        : this.defaultColor;
    }
  },
  {
    name: "entities",
    label: "Por empresa, pessoa ou negócio",
    mapping: new Map([
      ["empresa", { color: "#2e96d7", label: "Empresa" }],
      ["pessoa", { color: "#1bc559", label: "Pessoa" }],
      ["negocio", { color: "#dba217", label: "Negócio" }]
    ]),
    defaultColor: "#9393c2",
    colorFor: function(activity) {
      const key = activity.obj;

      return this.mapping.has(key)
        ? this.mapping.get(key).color
        : this.defaultColor;
    }
  }
];

module.exports = CalendarColorSchemes;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Calendar/calendar-color-schemes.js